export default {
  news: {
    listTitle: 'ニュース一覧',
    items: [
      {
        id: 'scholarship-repayment-2024',
        date: '2024年8月15日',
        category: '人事',
        title: '奨学金返還支援制度を導入いたしました。',
        summary: '当社は全正社員のための新しい奨学金返済支援プログラムを開始しました。このプログラムは、社員が金銭的な負担を軽減し、キャリアに集中できる環境を提供することを目的としています。',
        content: [
          '具体的には、プログラムでは毎月の奨学金返済の一部を会社が補助します。これにより、社員は経済的心配から解放され、職業スキルの向上や自己成長に専念できるようになります。',
          '当社では、売上兆円という大きな目標を達成することで、社会への貢献も拡大できると考えています。このプログラムは小さな一歩ですが、社会への大きな影響を生むための礎の一つとなることを期待しています。',
        ],
      },
      { id: 'relocation-chuo-2023', date: '2023年6月5日', category: '社内ニュース', title: '大阪市中央区に移転いたしました。', summary: '', content: [] },
      { id: 'trade-terminology-2015', date: '2023年4月1日', category: 'サービス更新', title: '貿易用語集ページを公開しました。', link: '/import-export-terms', summary: '', content: [] },
      { id: 'relocation-kita-2014', date: '2014年12月8日', category: '社内ニュース', title: '大阪市北区に移転しました。', summary: '', content: [] },
      { id: 'general-export-2008', date: '2008年5月23日', category: 'ライセンス・コンプライアンス', title: '一般包括輸出許可を取得しました。', summary: '', content: [] },
      { id: 'narcotic-importer-2004', date: '2004年12月6日', category: 'ライセンス・コンプライアンス', title: '麻薬等原料輸入業者業務届受理証明書を取得しました。', link: '/docs/import_edraw_materials.pdf', summary: '', content: [] },
      { id: 'narcotic-exporter-2004', date: '2004年12月6日', category: 'ライセンス・コンプライアンス', title: '麻薬等原料輸出業者業務届受理証明書を取得しました。', link: '/docs/raw_material_exports.pdf', summary: '', content: [] },
      { id: 'toxic-importer-2004', date: '2004年10月4日', category: 'ライセンス・コンプライアンス', title: '毒物劇物輸入業の登録を受けました。', link: '/docs/import_poison.pdf', summary: '', content: [] },
      { id: 'toxic-seller-2004', date: '2004年9月21日', category: 'ライセンス・コンプライアンス', title: '毒物劇物一般販売業の登録を受けました。', link: '/docs/poison_for_sale.pdf', summary: '', content: [] },
    ],
  },
  newsDetail: {
    recentNews: '最新ニュース',
    backToNews: 'ニュースに戻る',
    backToNewsList: 'ニュース一覧に戻る',
    notFound: {
      title: '記事が見つかりません',
      description: 'お探しのニュース記事は存在しないか、削除された可能性があります。',
      back: 'ニュース一覧に戻る',
    },
  },
  notFound: {
    title: 'このページは生成されていません',
    suggestion: 'このページについてもっと教えてください。生成します。',
  },
};
